export const pinterest = 'pinterest';
export const meta = 'meta';
export const google = 'google';
export const plaformUsageId = {
    [meta]: 'facebookCatalogId',
    [google]: 'googleDataFeedId',
    [pinterest]: 'pinterestDataFeedId'
};
